module.exports = __webpack_public_path__ + "static/media/upload.72fa5d04.svg";